import { CalendarEvent } from '../../types';
import { AppointmentEvent } from './variants/appointment-event';
import { AvailabilitySlotEvent } from './variants/availability-slot-event';
import { AvailableBlockEvent } from './variants/available-block-event';
import { CancelledAppointmentEvent } from './variants/cancelled-appointment-event';
import { ExceptionV2Event, ExceptionV3Event } from './variants/exception-event';
import { NonInteractiveSlotEvent } from './variants/non-interactive-slot';
import { ScheduleDefinitionEvent } from './variants/schedule-definition-event';
import { ScheduleRequestEvent } from './variants/schedule-request';
import { SlotStartLabelEvent } from './variants/slot-start-label';

interface Props {
  event: CalendarEvent;
}

export const EventCardSwitch = ({ event }: Props) => {
  switch (event.eventType) {
    case 'appointment':
      return <AppointmentEvent event={event} />;
    case 'scheduleDefinition':
      return <ScheduleDefinitionEvent event={event} />;
    case 'availabilitySlot':
      return <AvailabilitySlotEvent event={event} />;
    case 'availableBlock':
      return <AvailableBlockEvent event={event} />;
    case 'cancelledAppointment':
      return <CancelledAppointmentEvent event={event} />;
    case 'exceptionV2':
      return <ExceptionV2Event event={event} />;
    case 'exceptionV3':
      return <ExceptionV3Event event={event} />;
    case 'scheduleRequest':
      return <ScheduleRequestEvent event={event} />;
    case 'nonInteractiveSlot':
      return <NonInteractiveSlotEvent event={event} />;
    case 'slotsStartLabel':
      return <SlotStartLabelEvent event={event} />;
    default:
      return null;
  }
};
